import Button from './button'

export default Button


// WEBPACK FOOTER //
// ./src/components/base/button/index.js